import { useTranslation } from 'react-i18next'

import { Add } from '@mui/icons-material'
import { Box, Fab, Tooltip } from '@mui/material'
import { useField, useFormikContext } from 'formik'
import PageHeading from 'components/atoms/PageHeading'
import { IRtiRiskCriteriaOneDocument } from 'types'
import RtiRiskCriteriaOneDocumentRow from './RtiRiskCriteriaOneDocumentRow'

const RiskCriteriaOneDocumentList = ({ fieldProps, disabled }) => {
  const { t } = useTranslation()
  const [field] = useField<IRtiRiskCriteriaOneDocument[]>(fieldProps.name)
  const { setFieldValue } = useFormikContext() // Manually set field value in Formik state

  const handleAddEntity = () => {
    setFieldValue(fieldProps.name, [
      ...field.value,
      {
        measure: '',
        student_score: '',
        standard_score: '',
        date_given: '',
      },
    ])
  }

  return (
    <>
      <div style={{ padding: '10px' }}>
        {t('rti.list-performance-documents')}
      </div>
      
      {field?.value?.length > 0 ? (
          field?.value.map((value: IRtiRiskCriteriaOneDocument, index: number) => (

          <Box 
              className="transparent-background"
              key={`document_${index}`}
          >
            <RtiRiskCriteriaOneDocumentRow fieldProps={fieldProps} disabled={disabled} index={index} />
          </Box>
          ))
        ) : (
          <></>
        )}

        {!disabled &&
          <Tooltip title={`${t('common.add')}`} arrow placement='top'>
            <Fab
              variant='extended'
              aria-label='add'
              size='small'
              onClick={handleAddEntity}
              color='success'
              sx={{ margin: '1rem 0 0.5rem auto', boxShadow: 'none' }}
            >
              <Add style={{ fontSize: '1.8rem' }} /> {t('rti.add-performance-document')}
            </Fab>
          </Tooltip>
        }
    </>
  )
}

export default RiskCriteriaOneDocumentList
